document.addEventListener('DOMContentLoaded', () => {
  const bubbleEl = document.getElementById('cart-count-bubble');
  const countEls = document.querySelectorAll('[data-cart-count]');
  const labelEls = document.querySelectorAll('[data-cart-count-label]');

  let lastKnownCount = null;

  const renderCartCount = count => {
    countEls.forEach(el => {
      el.textContent = count;
    });

    labelEls.forEach(el => {
      el.textContent = `Cart with ${count} item${count === 1 ? '' : 's'}`;
    });

    if (bubbleEl) {
      bubbleEl.classList.toggle('is-empty', count === 0);
      bubbleEl.setAttribute('data-count', String(count));
    }
  };

  const fetchCartCount = async () => {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to load cart');
    }

    const cart = await response.json();
    return cart.item_count;
  };

  const updateCartBubble = async () => {
    try {
      const count = await fetchCartCount();
      lastKnownCount = count;
      renderCartCount(count);
      return count;
    } catch (error) {
      console.error('Cart bubble update failed:', error);
      return null;
    }
  };

  const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

  const refreshAfterAddToCart = async () => {
    const startingCount = lastKnownCount;

    // Try a few times because Dawn's AJAX add can complete slightly after submit fires
    const delays = [250, 500, 900, 1400];

    for (const delay of delays) {
      await wait(delay);

      try {
        const count = await fetchCartCount();

        if (startingCount === null || count !== startingCount || delay === delays[delays.length - 1]) {
          lastKnownCount = count;
          renderCartCount(count);
          return;
        }
      } catch (error) {
        console.error('Retry cart refresh failed:', error);
      }
    }
  };

  document.addEventListener(
    'submit',
    event => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('form[data-type="add-to-cart-form"]')) return;

      // Let existing AJAX logic handle the submit
      refreshAfterAddToCart();
    },
    true
  );

  updateCartBubble();

  window.updateCartBubble = updateCartBubble;
});